export default __webpack_public_path__ + "static/media/J5.841c7a8c.jpg";